// components/AddNewClientModal.jsx
import React, { useState, useEffect } from 'react'
import ApiClient from '../../../api/client'
import { useClientStore } from '../../../../store/useClientStore'

const apiClient = new ApiClient()

const AddNewClientModal = ({ isOpen, onClose }) => {
  const { addNewClient } = useClientStore()
  // const [formData, setFormData] = useState({
  //   client_name: '',
  //   email: '',
  //   program_id: '',
  //   // add more fields as needed
  // })

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [image, setImage] = useState(null)
  const [programId, setProgramId] = useState('')
  const [status, setStatus] = useState('')
  const [program, setProgram] = useState([])
  const [statusOption, setStatusOption] = useState([])

  // const statuses = [
  //   { id: 1, name: 'pending' },
  //   { id: 2, name: 'under review' },
  //   { id: 3, name: 'approved' },
  //   { id: 4, name: 'suspended' },
  // ]

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }))
  // }

  useEffect(() => {
    const fetchProgram = async () => {
      const { data, error } = await apiClient.fetchAllPrograms()
      if (data) {
        setProgram(data)
      }
    }
    fetchProgram()

    // setStatusOption(statuses)
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    await addNewClient(name, email, image, programId)
    onClose() // close modal after success
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex justify-center items-center">
      <div className="bg-white w-[80%] max-w-md p-6 rounded shadow">
        <h2 className="text-xl font-semibold mb-4">Add New Client</h2>
        <form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">
          <input
            type="text"
            name="client_name"
            placeholder="Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
            required
          />
          <input
            type="file"
            name="image"
            placeholder="image"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
            className="w-full p-2 border border-gray-300 rounded"
          />

          {/* <select
            name="status"
            id="status"
            value={status}
            className="w-full border mb-4 p-2 rounded"
            onChange={(e) => setStatus(e.target.value)}
            placeholder="Status"
          >
            <option value="">Select Status</option>
            {statuses
              ? statusOption.map((e) => (
                  <option key={e.id} value={e.name}>
                    {e.name}
                  </option>
                ))
              : alert(<span className="text-red-700">Select an option!</span>)}
          </select> */}

          <select
            name="program"
            id="program"
            value={programId}
            className="w-full border mb-4 p-2 rounded"
            onChange={(e) => setProgramId(parseInt(e.target.value))}
            placeholder="Program"
          >
            <option value="">Select Program</option>
            {program.map((prog) => (
              <option key={prog.id} value={prog.id}>
                {prog.name}
              </option>
            ))}
          </select>

          {/* <input
            type="text"
            name="program_id"
            placeholder="Program ID"
            value={programId}
            onChange={(e)=>setProgramId(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
          /> */}
          {/* Add dropdown if you want to show program names later */}
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Add Client
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AddNewClientModal
